<script setup>
import { useI18n } from 'vue-i18n';
import NextInput from 'dashboard/components-next/input/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const labels = defineModel({ type: Array, required: true });

const { t } = useI18n();

const moveUp = index => {
  if (index === 0) return;
  const items = [...labels.value];
  [items[index - 1], items[index]] = [items[index], items[index - 1]];
  labels.value = items;
};

const moveDown = index => {
  if (index === labels.value.length - 1) return;
  const items = [...labels.value];
  [items[index + 1], items[index]] = [items[index], items[index + 1]];
  labels.value = items;
};

const removeLabel = index => {
  labels.value = labels.value.filter((_, i) => i !== index);
};

const addLabel = () => {
  labels.value = [...labels.value, { title: '', color: '#1f93ff' }];
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-n-slate-11">
      {{ t('QUICK_SETUP.STEP_FUNNEL.DESCRIPTION') }}
    </p>

    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2 opacity-70">
        <div class="flex flex-col w-4 shrink-0" />
        <div
          class="w-8 h-8 border rounded shrink-0 border-n-weak bg-n-slate-3"
        />
        <div
          class="flex items-center w-full h-9 px-3 text-sm border rounded-md border-n-weak bg-n-slate-2 text-n-slate-11"
        >
          {{ t('QUICK_SETUP.STEP_FUNNEL.FIXED_NEW_CONTACT') }}
        </div>
        <div class="size-4 shrink-0" />
      </div>
      <div
        v-for="(label, index) in labels"
        :key="index"
        class="flex items-center gap-2"
      >
        <div class="flex flex-col">
          <button
            type="button"
            class="i-lucide-chevron-up size-4 text-n-slate-10 hover:text-n-slate-12 disabled:opacity-30"
            :disabled="index === 0"
            @click="moveUp(index)"
          />
          <button
            type="button"
            class="i-lucide-chevron-down size-4 text-n-slate-10 hover:text-n-slate-12 disabled:opacity-30"
            :disabled="index === labels.length - 1"
            @click="moveDown(index)"
          />
        </div>
        <input
          v-model="label.color"
          type="color"
          class="w-8 h-8 p-0 border-0 rounded cursor-pointer shrink-0"
        />
        <NextInput
          v-model="label.title"
          type="text"
          class="w-full"
          :placeholder="t('QUICK_SETUP.STEP_FUNNEL.NAME_PLACEHOLDER')"
        />
        <button
          type="button"
          class="i-lucide-trash-2 size-4 text-n-ruby-9 shrink-0"
          @click="removeLabel(index)"
        />
      </div>
    </div>

    <NextButton
      variant="faded"
      color="slate"
      size="sm"
      type="button"
      class="w-fit"
      icon="i-lucide-plus"
      :label="t('QUICK_SETUP.STEP_FUNNEL.ADD_LABEL')"
      @click="addLabel"
    />
    <p class="text-xs text-n-slate-10">
      {{ t('QUICK_SETUP.STEP_FUNNEL.FIXED_HINT') }}
    </p>
  </div>
</template>
